import { createContext } from 'react'
import { Fit } from 'types/fit'
import { PartialState, ValuesState } from './ReturnsFormModal'

type ReturnsContextProps = {
  customerFit?: Fit
  storedSavedFit: PartialState<ValuesState['sizes']>
  setStoredSavedFit: React.Dispatch<
    React.SetStateAction<PartialState<ValuesState['sizes']>>
  >
}

const ReturnsContext = createContext<ReturnsContextProps>({
  customerFit: undefined,
  storedSavedFit: {},
  setStoredSavedFit: () => undefined
})

export default ReturnsContext
